import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8uyj93ctm1: FaireBrandEntity = {
  token: "b_8uyj93ctm1",
  type: "brand",
  name: "W.A.Y. --Wonderful And Young",
  avatarUrl:
    "https://cdn.faire.com/fastly/8da2d0e1f11f9c3ab9c16f80130799676a008f2e5e2f5c3dc928da483e6b9f0a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/33160ba0fae5bc0d88177b24edb4807b208d690934565169ff20ed17f5fa934e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8da2d0e1f11f9c3ab9c16f80130799676a008f2e5e2f5c3dc928da483e6b9f0a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/33160ba0fae5bc0d88177b24edb4807b208d690934565169ff20ed17f5fa934e.png",
  location: "S El Monte, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 24,
  isInsider: true,
  description:
    "W.A.Y is a one-stop-shop fabric, apparel, manufacturing firm, and wholesale supplier of the finest quality and most innovative fabrics for multiple uses. Beginning with our custom yarns, fabric design, to garment construction; we knit, dye, cut, sew, print, and embroidery in our privately owned WRAP certified facilities. \n\nW.A.Y was created with a simple belief — that style should feel free, expressive, and wonderfully bold at any age. Rooted in the idea of Wonderful and Young, the brand celebrates a spirit that never grows old: confidence, creativity, and the joy of dressing beautifully.\n\nEach collection blends effortless silhouettes with thoughtful details, pairing natural textures like linen and mesh with prints that spark personality. W.A.Y pieces are made to live in — to move with you through everyday moments, adventures, travels, and memories. \n\nW.A.Y is for the woman who dresses for herself. The one who embraces color, texture, and pattern. The one who loves clothes that feel as good as they look — airy, flattering, and full of life. She’s not defined by age, trends, or limits. She defines her own way.\n\nBecause wonderful isn’t about youth —It’s about how you feel. And feeling young is a state of mind.\n\nW.A.Y — Wonderful and Young. Always. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:09.561Z",
    importedBy: "entity-db-cli",
  },
};
